// extracted by mini-css-extract-plugin
var _1 = "PostTopicWithBreadcrumbs-module__animateUploadProgressBarWidth--CM8qa";
var _2 = "PostTopicWithBreadcrumbs-module__animatedBackground--mN28T";
var _3 = "PostTopicWithBreadcrumbs-module__item--N6Emm";
var _4 = "PostTopicWithBreadcrumbs-module__popOver--eLrZy";
var _5 = "PostTopicWithBreadcrumbs-module__remove--_2J0E";
var _6 = "PostTopicWithBreadcrumbs-module__removeButton--lo60k";
var _7 = "PostTopicWithBreadcrumbs-module__topicNameContainer--T6FhH";
var _8 = "PostTopicWithBreadcrumbs-module__topicNameInner--VBrYt";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "item", _4 as "popOver", _5 as "remove", _6 as "removeButton", _7 as "topicNameContainer", _8 as "topicNameInner" }
